type ChildrenFiltersType = {
  field: string;
  value: string[];
};

// This function maps the filters from the body of the request to the format expected by the API.
export const mapV2ChildrenFilters = (
  bodyFilters: Record<string, unknown> = {},
) => {
  const childrenFilters: ChildrenFiltersType[] = [];
  const fieldMap: Record<string, string[]> = {};

  Object.entries(bodyFilters)?.forEach(([key, value]) => {
    const field = key.replace('filter.', '');
    const values = Array.isArray(value) ? value.map(String) : [String(value)];

    if (fieldMap[field]) {
      fieldMap[field].push(...values);
    } else {
      fieldMap[field] = values;
      childrenFilters.push({ field: field, value: fieldMap[field] });
    }
  });

  return childrenFilters;
};
